/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Warning_Too_Many_ClausesInputs */

const en_warning_too_many_clauses = /** @type {(inputs: Warning_Too_Many_ClausesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More than ${i?.max} parts in the query, the rest is ignored`)
};

const de_warning_too_many_clauses = /** @type {(inputs: Warning_Too_Many_ClausesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mehr als ${i?.max} Teile in der Abfrage, der Rest wird ignoriert`)
};

/**
* | output |
* | --- |
* | "More than {max} parts in the query, the rest is ignored" |
*
* @param {Warning_Too_Many_ClausesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_too_many_clauses = /** @type {((inputs: Warning_Too_Many_ClausesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Too_Many_ClausesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_too_many_clauses(inputs)
	return en_warning_too_many_clauses(inputs)
});